<template>
  <div class="max-w-lg w-full mx-auto">
    <div class="mt-8 mx-auto max-w-7xl px-2 sm:mt-4">
      <div class="text-center">
        <h1 class="text-2xl tracking-tight font-extrabold text-gray-900 sm:text-2xl md:text-2xl whitespace-nowrap">
          <span class="block text-mygrad">Select your ceremony</span>
        </h1>
        <p class="mt-2 text-base text-gray-600">
          Choose the graduation ceremony where your photo was taken.
        </p>
      </div>
    </div>
    <form class="space-y-4 text-gray-700 mt-6" @submit.prevent="submit">
      <div class="w-full">
        <label class="block mb-1" for="formGridCode_event">Your Graduation Date</label>
        <select
          v-model="selectedEvent"
          class="w-full h-10 px-3 text-base placeholder-gray-600 border rounded-lg focus:shadow-outline"
          id="formGridCode_event"
          name="event"
        >
          <option disabled :value="null">Select your graduation date</option>
          <option
            v-for="ceremony in filterEvents"
            :value="ceremony['id']"
            :key="ceremony['id']"
          >
            {{ formatCeremonyOption(ceremony) }}
          </option>
        </select>
      </div>
      <div v-if="rememberedDetails" class="rounded-lg border border-gray-300 bg-white p-4 text-left">
        <div class="text-sm text-gray-600">Welcome back</div>
        <div class="mt-1 text-base font-semibold text-gray-900">
          Continue as {{ rememberedDetails.name }}
        </div>
        <div class="mt-1 text-sm text-gray-700">
          We can prefill your details on the next step.
        </div>
        <div class="mt-3 flex flex-col gap-2">
          <button
            type="button"
            class="inline-flex items-center justify-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium w-full rounded-md text-white bg-blue-500 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            @click="useRemembered"
          >
            Use saved details
          </button>
          <button
            type="button"
            class="inline-flex items-center justify-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium w-full rounded-md text-gray-700 bg-white hover:bg-gray-50"
            @click="submit"
          >
            Take a selfie instead
          </button>
        </div>
      </div>
      <button
        type="submit"
        class="inline-flex items-center justify-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium w-full rounded-md text-white bg-blue-500 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        :disabled="!selectedEvent"
      >
        Continue
      </button>
    </form>
  </div>
</template>

<script>
import { getSnapshotConfig } from "../../snapshotConfig";
export default {
  name: "SnapshotCeremonySelect",
  props: {
    events: Array,
    selected: String,
    getRememberedDetails: Function,
    rememberEnabled: { type: Boolean, default: false },
  },
  data() {
    return {
      selectedEvent: this.selected || null,
    };
  },
  computed: {
    snapshotConfig() {
      return getSnapshotConfig(this.$route.params.uni);
    },
    rememberedDetails() {
      if (!this.rememberEnabled || !this.selectedEvent || !this.getRememberedDetails) return null;
      const details = this.getRememberedDetails(this.selectedEvent);
      return details || null;
    },
    filterEvents() {
      const isPrintOnly = this.$route.query.printOnly === "true"
        && this.$route.query.showAll != 'true';

      let filtered = this.events;

      if (this.snapshotConfig.ceremonyLabelOnly) {
        // Only show events with a label for UCD
        filtered = filtered.filter(ceremony => ceremony.label);
      }

      if (!isPrintOnly) {
        return filtered;
      }

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return filtered.filter(ceremony => {
        const ceremonyDate = new Date(ceremony.datetime);
        ceremonyDate.setHours(0, 0, 0, 0);
        return ceremonyDate.getTime() === today.getTime();
      });
    },
  },
  methods: {
    submit() {
      if (!this.selectedEvent) return;
      this.$emit("submit", this.selectedEvent);
    },
    useRemembered() {
      if (!this.selectedEvent) return;
      this.$emit("use-remembered", this.selectedEvent);
    },
    formatDate(dateString) {
      return new Date(dateString).toLocaleDateString('en-GB', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
      });
    },
    formatCeremonyOption(ceremony) {
      if (!ceremony) {
        return '';
      }
      if (this.snapshotConfig.ceremonyLabelOnly) {
        return ceremony.label || this.formatDate(ceremony.datetime);
      }
      const formattedDate = this.formatDate(ceremony.datetime);
      return ceremony.label ? `${formattedDate} - ${ceremony.label}` : formattedDate;
    },
  },
};
</script>
